// extracted by mini-css-extract-plugin
export default {"comment":"comment--yJk9F"};